import { useAuthStore } from "@/stores/auth";
import { useCompanyStore } from "@/stores/company";
import type { TenantModule } from "@/interfaces/tenants";
import type { RouteLocationNormalized } from "vue-router";

export const verifyRoutePermission = (async (to: RouteLocationNormalized) => {
  const { permission, superAdminOnly, requiresModule } = to.meta

  const authStore = useAuthStore();
  const companyStore = useCompanyStore();

  // Verifica se a rota é restrita à empresa super admin (control plane)
  if (superAdminOnly && !companyStore.isSuperAdmin) {
    return { name: 'denied' }
  }

  // Verifica se a empresa tem o módulo ativo (ar_modulos_ativos)
  if (requiresModule && !companyStore.hasModule(requiresModule as TenantModule)) {
    return { name: 'denied' }
  }

  if (!permission) return;

  const permissions = Array.isArray(permission) ? permission : [permission as string];

  // Verifica a permissão caso a rota seja protegida com permissão
  if (!permissions.every(p => authStore.hasPermission(p))) {
    return { name: 'denied' }
  }
});